import React from "react";
import { AlertTriangle, RotateCcw, Trash2, X } from "lucide-react";
import { money } from "../../lib/format";

export const OrgImpactDialog = ({ impact, busy, onClose, onDelete }) => {
  const [form, setForm] = React.useState({ confirmation_name: "", reason: "", cascade_children: false });
  if (!impact) return null;
  const canSubmit = form.confirmation_name === impact.node.node_name && form.reason.trim().length >= 3
    && (!impact.descendant_count || form.cascade_children);
  return (
    <div className="modal-backdrop" data-testid={`org-node-impact-drawer-${impact.node.id}`} onMouseDown={onClose}>
      <div className="modal org-impact-modal" onMouseDown={(event) => event.stopPropagation()}>
        <div className="modal-head"><div><span className="eyebrow">İŞLEM ÖNCESİ ETKİ</span><strong>{impact.node.node_name}</strong></div>
          <button className="icon-button" data-testid="org-impact-close-btn" onClick={onClose}><X size={16}/></button></div>
        <div className="org-impact-content">
          <div className="org-impact-grid" data-testid="org-impact-counts">
            <span>Alt kayıt<strong>{impact.descendant_count}</strong></span>
            <span>Hedef satırı<strong>{impact.target_rows}</strong></span>
            <span>Üretim kaydı<strong>{impact.production.rows}</strong></span>
            <span>İsim eşleştirme<strong>{impact.aliases}</strong></span>
            <span>Kullanıcı kapsamı<strong>{impact.users}</strong></span>
          </div>
          <div className="org-impact-financial" data-testid="org-impact-financials">
            <span>Bağlı net prim <strong>{money(impact.production.premium, false)}</strong></span>
            <span>Bağlı komisyon <strong>{money(impact.production.commission, false)}</strong></span>
          </div>
          {impact.descendant_count > 0 && <label className="org-warning-check">
            <input data-testid="org-delete-cascade-checkbox" type="checkbox" checked={form.cascade_children}
              onChange={(event) => setForm({ ...form, cascade_children: event.target.checked })}/>
            <AlertTriangle size={15}/><span>Bu kayıtla birlikte {impact.descendant_count} alt kaydı da Silinen Kayıtlar alanına taşı.</span>
          </label>}
          <label>Gerekçe<textarea data-testid="org-delete-reason-input" rows={3} value={form.reason}
            onChange={(event) => setForm({ ...form, reason: event.target.value })}/></label>
          <label>Onay için <b>{impact.node.node_name}</b> yazın
            <input data-testid="org-delete-confirmation-input" value={form.confirmation_name}
              onChange={(event) => setForm({ ...form, confirmation_name: event.target.value })}/></label>
          <p className="muted"><RotateCcw size={13}/> Bağlı veriler fiziksel olarak silinmez; işlem geçmişinden geri alınabilir.</p>
        </div>
        <div className="modal-foot"><button className="outline-button" data-testid="org-delete-cancel-btn" onClick={onClose}>Vazgeç</button>
          <button className="danger-button" data-testid="org-delete-confirm-btn" disabled={!canSubmit || busy}
            onClick={() => onDelete({ ...form, preview_token: impact.preview_token })}><Trash2 size={14}/>{busy ? "İşleniyor…" : "Silinenlere Taşı"}</button></div>
      </div>
    </div>
  );
};